import fall25 from './fall25'
import spring25 from './spring25'
import spring26 from './spring26'
import spring27 from './spring27'

const state = {
  currentSite: 'spring27',
  previousSite: 'spring26'
}

const modules = {
  spring25,
  fall25,
  spring26,
  spring27
}

export default {
  state,
  modules,
  namespaced: true
}
